import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { sendEmailCampaign as sendEmailCampaignApi } from "../../../../api/emailCampaigns/emailCampaigns";
import { Link } from "react-router-dom";
import { NOTIFICATION_EMAIL_CAMPAIGN_ACTIONS } from '../../../../config/notifications';
import { store } from '../../../../store/store';
import { hideNotification } from '../../../../store/actions/notification';

function SendEmailCampaign(props) {
  const [showSendEmailCampaignModal, setShowSendEmailCampaignModal] = useState(false);
  const { index, actionCallback, emailCampaign, showIcon } = props;

  const sendEmailCampaign = () => {
    sendEmailCampaignApi({
      data :{
        id: emailCampaign.id
      },
      notificationId: NOTIFICATION_EMAIL_CAMPAIGN_ACTIONS
    }).then((response) => {
      setShowSendEmailCampaignModal(false);
      if (response && response.status === 200) {
        actionCallback();
      }
    });
  };

  return (<Fragment>
    {!showIcon ?
      <Fragment>
        <Button
          color="primary"
          size="sm"
          className="btn-warning"
          type="button"
          id={`send-email-campaign-icon-${index}`}
          onClick={() => {
            store.dispatch(hideNotification());
            setShowSendEmailCampaignModal(true)
          }}
        >
          <FormattedMessage
            id="messages.send_email_campaign" />
        </Button>
        <UncontrolledTooltip
          delay={0}
          target={`send-email-campaign-icon-${index}`}
          modifiers={{
            preventOverflow: {
              enabled: true,
              boundariesElement: "body",
            },
          }}
        >
          <FormattedMessage
            id="messages.send_email_campaign" />
        </UncontrolledTooltip>
      </Fragment> :
      <Fragment>
        <Link
          to="#"
          className="cursor-pointer px-2 mx-2 link-icon-color"
          id={`send-email-campaign-icon-` + props.index}
          onClick={() => setShowSendEmailCampaignModal(true)}
        >
          <FontAwesomeIcon
            size="lg"
            className="cursor-pointer"
            pointerEvents="none"
            icon={faEnvelope}
          />
        </Link>
        <UncontrolledTooltip
          delay={0}
          target={`send-email-campaign-icon-${props.index}`}
          modifiers={
            {
              preventOverflow: {
                enabled: true,
                boundariesElement: 'body'
              }
            }
          }
        >
          <FormattedMessage
            id="messages.send_email_campaign" />
        </UncontrolledTooltip>
      </Fragment>
    }

    <ConfirmationModal
      showModal={showSendEmailCampaignModal}
      closeModal={() => setShowSendEmailCampaignModal(false)}
      confirmationYes={sendEmailCampaign}
      messageId="messages.confirm_send_email_campaign"
    />
  </Fragment>
  );
}

export { SendEmailCampaign };
